import { useMemo } from 'react';

import type { TranslationKey } from '@change-corgi/core/i18n';
import { type I18nUtilities, useI18n } from '@change-corgi/core-react/i18n';

export type TranslatableLabel = TranslationKey | ((i18n: I18nUtilities) => string);

export function useResolvedLabel(label: TranslatableLabel): string;
export function useResolvedLabel(label: TranslatableLabel | undefined): string | undefined;
export function useResolvedLabel(label: TranslatableLabel | undefined): string | undefined {
	const i18n = useI18n();
	return useMemo(() => {
		if (label === undefined) return undefined;
		return typeof label === 'function' ? label(i18n) : i18n.typedTranslate(label);
	}, [label, i18n]);
}
